/**
 * 初期設定処理
 */

import $ from 'jquery';

$.ajaxSetup({
    headers: {
        // csrf-tokenセット
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});
